module.exports = __webpack_public_path__ + "img/telo-proiettore.afb04095.jpg";